(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BackupConfirmController', BackupConfirmController);

    BackupConfirmController.$inject = ['$scope', '$injector', '$uibModalInstance', 'ModalConstructor', 'SystemConfigService', 'dataAction', 'confirmData'];

    function BackupConfirmController($scope, $injector, $uibModalInstance, ModalConstructor, SystemConfigService, dataAction, confirmData) {
        var vm = this;
        vm.requestRunning = false;

        if (dataAction) {
            vm.action = dataAction.action;
            vm.data = confirmData;

            if (dataAction.getPath) {
                vm.requestRunning = true;
                SystemConfigService.getSystemConfig().then(function (data) {
                    vm.requestRunning = false;
                    vm.data = data.systemBackupConfig.path;
                    dataAction.methodParam = data.systemBackupConfig.path;
                }).catch(function (response) {
                    vm.close();
                    SystemConfigService.errorModalConstructor(response, 'get');
                });
            }

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            vm.confirmAction = function () {
                vm.requestRunning = true;
                var service = dataAction.service ? $injector.get(dataAction.service) : SystemConfigService;
                service[dataAction.methodService](dataAction.methodParam).then(success).catch(error);
            }
        }

        function success(data) {
            vm.requestRunning = false;
            var modalInstance;
            if (!dataAction.confirmation) {
                modalInstance = SystemConfigService.successModalConstructor(vm.action);
            }
            if (dataAction.methodExtra) {
                dataAction.methodExtra(data, modalInstance);
            }
        }

        function error(response) {
            vm.requestRunning = false;
            var modalInstance = SystemConfigService.errorModalConstructor(response, vm.action);
            if (response.status == 409) {
                modalInstance.closed.then(ModalConstructor.closeAll);
            }
        }

    }
})();
